import LogoMark from "./LogoMarkTable";

export default LogoMark;
